export default function Services() {
  const services = [
    {
      icon: 'ri-shirt-line',
      title: 'Custom Suits',
      description: 'Perfectly tailored suits crafted from premium fabrics with precise measurements and expert craftsmanship. Choose from hundreds of fabric options and styles.',
      features: ['Premium Fabrics', 'Perfect Fit', 'Style Customization']
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Custom Shirts',
      description: 'Handmade dress shirts designed to your exact specifications. Select from luxury fabrics, collar styles, cuff designs, and personalized monograms.',
      features: ['Luxury Materials', 'Custom Details', 'Monogramming']
    },
    {
      icon: 'ri-scissors-line',
      title: 'Expert Alterations',
      description: 'Professional tailoring and alterations to ensure your garments fit flawlessly. From simple adjustments to complete reconstructions.',
      features: ['Quick Turnaround', 'Precision Work', 'All Garments']
    },
    {
      icon: 'ri-home-office-line',
      title: 'House & Office Calls',
      description: 'Convenient consultations at your location nationwide. Our traveling consultants bring fabric samples and expertise directly to you.',
      features: ['Nationwide Service', 'Flexible Scheduling', 'Personal Service']
    },
    {
      icon: 'ri-palette-line',
      title: 'Style Consultation',
      description: 'Expert guidance on fabrics, cuts, and styles that complement your body type and personal aesthetic. Professional advice at every step.',
      features: ['Expert Advice', 'Trend Insights', 'Personal Styling']
    },
    {
      icon: 'ri-mail-send-line',
      title: 'Fabric Swatches',
      description: 'Browse our extensive fabric collection from home. We mail swatches to our repeat customers.',
      features: ['Free Samples', 'Home Review', 'Wide Selection']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our <span className="text-[#C9A961]">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive <strong>custom tailoring services</strong> designed to deliver the perfect fit and exceptional quality
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#C9A961]/30"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-[#C9A961] mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>

              <a 
                href="#consultation" 
                className="inline-flex items-center mt-6 text-[#C9A961] font-semibold hover:text-[#B89851] transition-colors group-hover:translate-x-2 duration-300 whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}